// redux/slice/sideMenuSlice.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

type SideMenuTarget =
  | "home"
  | "profile"
  | "settings"
  | "about"
  | "history"
  | "login"
  | null;

interface SideMenuState {
  lastClicked: SideMenuTarget;
  timestamp: number;
}

const initialState: SideMenuState = {
  lastClicked: null,
  timestamp: 0,
};

const sideMenuSlice = createSlice({
  name: "sideMenu",
  initialState,
  reducers: {
    sideMenuClicked: (state, action: PayloadAction<SideMenuTarget>) => {
      state.lastClicked = action.payload;
      state.timestamp = Date.now(); // important for re-triggering
    },
    clearSideMenuClick: (state) => {
      state.lastClicked = null;
    },
  },
});

export const { sideMenuClicked, clearSideMenuClick } =
  sideMenuSlice.actions;

export default sideMenuSlice.reducer;
